import type { CSSProperties, FC, ReactNode } from 'react'

import { IconArt } from '@/components/generals/icon-art'
import { Scallop } from '@/components/generals/scallop'
import { PERKS } from '@/constants/home'

export const Perks: FC = (): ReactNode => {
    return (
        <section aria-labelledby='perks-title' className='relative bg-cream pt-16 pb-24 sm:pt-20 sm:pb-32'>
            <Scallop className='text-cream' />

            <h2 id='perks-title' className='sr-only'>
                Why work with us
            </h2>

            <ul className='mx-auto grid max-w-6xl gap-14 px-5 sm:px-8 md:grid-cols-3 md:gap-10'>
                {PERKS.map((perk, index) => (
                    <li
                        key={perk.title}
                        className='group reveal text-center'
                        style={{ '--reveal-delay': `${index * 150}ms` } as CSSProperties}
                    >
                        <IconArt
                            icon={perk.icon}
                            shape={perk.shape}
                            colorClassName={perk.color}
                            accentClassName={perk.accent}
                            tilt={index % 2 === 0 ? 'left' : 'right'}
                            className='mx-auto size-44'
                        />

                        <h3 className='mt-7 font-heading text-[2rem] leading-none transition-colors duration-300 group-hover:text-coral'>
                            {perk.title}
                        </h3>

                        <p className='mx-auto mt-3 max-w-xs leading-relaxed text-plum/75'>
                            {perk.text}
                        </p>
                    </li>
                ))}
            </ul>
        </section>
    )
}
